import { Link } from "react-router-dom";
import {
  LayoutDashboard,
  BarChart3,
  Store,
  ClipboardList,
  Users,
  CalendarDays,
  ListChecks,
  ShieldAlert,
  MessagesSquare,
  FileSignature,
  FileText,
  HelpCircle,
  Database,
  ExternalLink,
} from "lucide-react";
import { UserPill } from "@/components/sections";

const LOGO_URL = "/logo-transparent.png";

export const SIDEBAR_NAV = [
  { id: "dashboard", label: "Dashboard", Icon: LayoutDashboard },
  { id: "vendor-stats", label: "Vendor Stats", Icon: BarChart3 },
  { id: "vendor-form-data", label: "Vendor Form data", Icon: Store },
  { id: "vendor-list", label: "Vendor List", Icon: ClipboardList },
  { id: "couples-form-data", label: "Couples Form data", Icon: Users },
  { id: "couple-list", label: "Couple List", Icon: ClipboardList },
  { id: "calendar", label: "Calendar", Icon: CalendarDays },
  { id: "tasks", label: "Tasks", Icon: ListChecks },
  { id: "signin-activity", label: "Sign-in activity", Icon: ShieldAlert },
  { id: "consultation", label: "Consultation", Icon: MessagesSquare },
  { id: "contracts", label: "Contracts", Icon: FileSignature },
  { id: "documents", label: "Documents", Icon: FileText },
  { id: "enquiry", label: "Enquiry", Icon: HelpCircle },
  { id: "backup", label: "Backup", Icon: Database },
];

export const AdminHeader = ({ user, onLogout }) => (
  <header className="relative z-20 flex items-center justify-between gap-6 px-6 md:px-12 pt-5 md:pt-7">
    <Link
      to="/"
      className="flex items-center gap-3 hover:opacity-80 transition-opacity"
    >
      <img
        src={LOGO_URL}
        alt=""
        aria-hidden
        className="h-8 w-8 object-contain"
      />
      <span className="font-accent text-[11px] tracking-[0.25em] text-[var(--ld-gold-deep)]">
        Luxé · Admin
      </span>
    </Link>
    <div className="flex items-center gap-3">
      <Link
        to="/vendor-listing"
        target="_blank"
        data-testid="open-vendor-listing"
        className="inline-flex items-center gap-2 px-4 py-2 text-[11px] tracking-[0.18em] uppercase border border-[var(--ld-ink)]/40 text-[var(--ld-ink)] hover:bg-[var(--ld-ink)] hover:text-[var(--ld-gold)] transition-colors"
      >
        <ExternalLink size={12} strokeWidth={1.6} />
        Vendor Listing
      </Link>
      {user && <UserPill user={user} onSignOut={onLogout} />}
      {/* Legacy button retained for the admin-logout test-id */}
      <button
        data-testid="admin-logout"
        onClick={onLogout}
        className="sr-only"
        aria-hidden
        tabIndex={-1}
      >
        Sign out
      </button>
    </div>
  </header>
);

export const AdminSidebar = ({ section, onSetSection }) => (
  <aside
    data-testid="admin-sidebar"
    className="md:w-60 md:shrink-0 md:border-r md:border-[var(--ld-border)] md:pr-6"
  >
    <p className="font-accent text-[10px] tracking-[0.3em] uppercase text-[var(--ld-gold-deep)] mb-4">
      Workspace
    </p>
    <nav className="flex md:flex-col gap-1 overflow-x-auto md:overflow-visible no-scrollbar">
      {SIDEBAR_NAV.map(({ id, label, Icon }) => {
        const active = section === id;
        return (
          <button
            key={id}
            type="button"
            data-testid={`nav-${id}`}
            onClick={() => onSetSection(id)}
            className={
              "group flex items-center gap-3 px-4 py-3 text-[11px] tracking-[0.18em] uppercase whitespace-nowrap transition-colors duration-300 border-l-2 " +
              (active
                ? "bg-[var(--ld-ink)] text-[var(--ld-gold)] border-[var(--ld-gold)]"
                : "bg-transparent text-[var(--ld-ink)] border-transparent hover:border-[var(--ld-gold)]/60 hover:bg-[var(--ld-ivory-warm)]/40")
            }
          >
            <Icon size={14} strokeWidth={1.6} />
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  </aside>
);
